import { T } from '@tribeplatform/react-components/i18n'
import { Link } from '@tribeplatform/react-components/Link'
import { HelperText } from '@tribeplatform/react-ui-kit/HelperText'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'
import { Text } from '@tribeplatform/react-ui-kit/Text'

interface Props {
  domain: string
}

export const StatusActive = ({ domain }: Props) => {
  const url = `https://${domain}`

  return (
    <div className="flex flex-col space-y-3 items-center">
      <SvgIcon
        name="status-success"
        size="6x"
        className="text-line-positive my-6"
      />
      <HelperText status="success" highlighted>
        <Text>
          <T
            defaultMessage="Well done! Your site is now accessible at {domain}. You’ll be redirected to the new domain in a few seconds."
            id="Admin.DomainTransfer.Active"
            values={{
              domain: (
                <Link variant="accent" href={url}>
                  <strong className="font-mono">{domain}</strong>
                </Link>
              ),
            }}
          />
        </Text>
      </HelperText>
    </div>
  )
}
